export const formatTicker = (ticker: string | undefined | null): string => {
  if (!ticker) return "";
  return ticker.replace(/\.SA$/i, "");
};

export const isValidCompanyTicker = (ticker: string | undefined | null): boolean => {
  if (!ticker) return false;
  
  // If it's a Brazilian ticker (ends with .SA or has 4 letters followed by numbers)
  // Let's check the base ticker without .SA
  const baseTicker = formatTicker(ticker).toUpperCase();
  
  // If it doesn't look like a Brazilian ticker (e.g., AAPL, MSFT), we assume it's valid
  // Brazilian tickers usually have 4 letters (or letters+numbers like B3SA3) followed by 1 or 2 digits
  const brMatch = baseTicker.match(/^[A-Z0-9]{4}(\d{1,2})$/);
  
  if (brMatch) {
    const num = parseInt(brMatch[1], 10);
    // Valid equity/unit endings: 
    // 3 (ON), 4 (PN), 5 (PNA), 6 (PNB), 11 (Units/FIIs/ETFs)
    // 32, 33, 34, 35, 39 (BDRs)
    const validEndings = [3, 4, 5, 6, 11, 32, 33, 34, 35, 39];
    
    if (!validEndings.includes(num)) {
      return false; // Filter out subscriptions (1, 2, 9, 10, 12, etc.)
    }
  }
  
  return true;
};
